<div class="bg-grey">
  <div class="box-tit">
    <span class="tit">컨텐츠 채널</span>
  </div>
  <a href="http://home.bbwithu.com" target="_self">
    <div contents-channel class="menu-contents"></div>
  </a>
  <div class="box-tit">
    <span class="tit">밸런스브레인 채널</span>
  </div>
  <div list-flat class="menu-balancebrain"
    [data]="
      [{desc: '홈페이지', src: 'assets/images/ch_icon_03.png', link: 'https://goo.gl/zXh8KK'},
      {desc: '공식 블로그', src: 'assets/images/ch_icon_04.png', link: 'http://blog.naver.com/pyundoori'},
      {desc: '카페 스펙트럼', src: 'assets/images/ch_icon_05.png', link: 'http://cafe.naver.com/balancebrain'},
      {desc: '카카오 플러스친구', src: 'assets/images/ch_icon_08.png', link: 'http://plus.kakao.com/home/hbrddvyp'}]"
    cols="2"></div>
  <div class="box-tit">
    <span class="tit">고객센터</span>
  </div>
  <a [href]="getCenterCall()"><div phone-consult class="menu-call"></div></a>
</div>
